import React, { createContext, useContext, useEffect, useState } from "react";

interface Viewport {
  isMobile: boolean;
  isDesktop: boolean;
}

export const ViewportContext = createContext<Viewport>({
  isMobile: !(window.innerWidth > 992),
  isDesktop: window.innerWidth > 992,
});

export const ViewportProvider = ({ children }: { children: React.ReactNode }) => {
  const [width, setWidth] = useState(window.innerWidth);

  const handleResize = () => setWidth(window.innerWidth);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return <ViewportContext.Provider value={{ isMobile: !(width > 992), isDesktop: width > 992 }}>{children}</ViewportContext.Provider>;
};

export function useViewport() {
  return useContext<Viewport>(ViewportContext);
}
